import { paperStyles, zIndexStyles } from '@festina-life/ui/libs'
import { PopoverPanel, Transition } from '@festina-life/ui/structure'
import cx from 'classnames'
import { type ComponentProps, Fragment, type ReactNode, Suspense } from 'react'

type Anchor = ComponentProps<typeof PopoverPanel>['anchor']

type Props = {
  children: ReactNode
  anchor: Anchor
  className?: string
  onClose?: () => void
}

export const ActionsMenuPanel = ({
  children,
  anchor,
  className,
  onClose,
}: Props) => (
  <Transition
    as={Fragment}
    enter="transition ease-out duration-200"
    enterFrom="opacity-0 translate-y-1"
    enterTo="opacity-100 translate-y-0"
    leave="transition ease-in duration-150"
    leaveFrom="opacity-100 translate-y-0"
    leaveTo="opacity-0 translate-y-1"
    afterLeave={onClose}
  >
    <PopoverPanel
      isShowingBackdrop
      className={cx(
        'fixed right-1.5 rounded-lg p-2 w-full max-w-md! shadow-lg overscroll-contain',
        paperStyles({ isFaded: false, borders: ['all'] }),
        zIndexStyles('popovers'),
        className,
      )}
      anchor={anchor}
    >
      <Suspense>{children}</Suspense>
    </PopoverPanel>
  </Transition>
)
